import { Select } from 'antd';
import React, { useState } from 'react';

interface statusFilter {
  title: string;
  value: string;
}
interface Props {
  filterBy: statusFilter[];
  handleStateValue: Function;
}
const { Option } = Select;

const DropdownItem = ({
  filterBy,

  handleStateValue
}: Props) => {
  const [localFilterState, setLocalFilterState] = useState('');
  handleStateValue(localFilterState);
  const handleChange = (value: { value: string; label: React.ReactNode }) => {
    console.log(value);
    setLocalFilterState(value.value);
  };

  return (
    <Select
      labelInValue
      // defaultValue={{ value: filterBy[0].value, label: filterBy[0].title }}
      placeholder="선택"
      onChange={handleChange}
    >
      {(filterBy || []).map((item) => (
        <Option value={item.value}>{item.title}</Option>
      ))}
    </Select>
  );
};

export default DropdownItem;
